import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@sib/ui';

type DetailsFieldVariant = 'default' | 'block';

const DETAILS_FIELD_CONTENT_CLASS_NAME: Record<DetailsFieldVariant, string> = {
  default: 'details-field-value',
  block: 'details-field-block',
};

interface DetailsFieldProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  variant?: DetailsFieldVariant;
}

export const DetailsField = ({
  label,
  children,
  className,
  variant = 'default',
  ...props
}: DetailsFieldProps) => (
  <div
    {...props}
    className={cn(
      'border-border flex min-w-0 flex-col gap-1 border-b py-3',
      className
    )}
  >
    <span className="text-muted-foreground text-sm">{label}</span>
    <div className={DETAILS_FIELD_CONTENT_CLASS_NAME[variant]}>{children}</div>
  </div>
);
